const addTogglePrevNextButtonsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextButtonsState = () => {
    if (emblaApi.canScrollPrev()) {
      prevBtn.classList.remove("embla__button--disabled")
    } else {
      prevBtn.classList.add("embla__button--disabled")
    }

    if (emblaApi.canScrollNext()) {
      nextBtn.classList.remove("embla__button--disabled")
    } else {
      nextBtn.classList.add("embla__button--disabled")
    }
  }

  togglePrevNextButtonsState()

  emblaApi.on("select", togglePrevNextButtonsState).on("reinit", togglePrevNextButtonsState)
}

export const addPrevNextButtonClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => emblaApi.scrollPrev()
  const scrollNext = () => emblaApi.scrollNext()

  prevBtn.addEventListener("click", scrollPrev, false)
  nextBtn.addEventListener("click", scrollNext, false)

  addTogglePrevNextButtonsActive(emblaApi, prevBtn, nextBtn)
}
